import React, { useState, useEffect } from 'react';

import { Button, Dropdown, DropdownButton, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';

import { faWallet, faCreditCard, faUpload, faSave, faSync  } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import openLoadCard from '../includes/open-load-card.js';
import openLocalWallet from '../includes/open-local-wallet.js';


const CardView = ({app, scheme, card, currency, size}) => {
	const theapp = app;
	const widgetsize = size;

	const mvcmywidget = theapp.getMvcMyWidget();

	const context = {currentscheme: scheme, currentcard:card, currency};

	var ischecking = false;
	var setIsChecking= (val) => { ischecking = val};

	const [showlocalwallet, setShowLocalWallet] = useState(true);
	const [showremotewallet, setShowRemoteWallet] = useState(true);

	const [balance, setBalance] = useState('');
	const [balance_string, setBalanceString] = useState('');

	const [card_address, setCardAddress] = useState('');

	const [credit_balance, setCreditBalance] = useState('');

	const onRefresh = async () => {
		theapp.refreshPage();
	}

	const onLoadCard = async () => {
		let amount=0;

		return openLoadCard(theapp, context, amount);
	}


	const onOpenWallet = async () => {
		console.log('CardView.onOpenWallet called');

		return openLocalWallet(theapp, context);
	}

	const onRefreshPage = async (eventname, params) => {
		// onRefreshPage is equivalent to a static function
		// since it is registered in useEffect and correspond
		// to the first call to PayWidget
		console.log('CardView.onRefreshPage called');

		if (!ischecking) {
			console.log('calling checkNavigationState after page refresh');
			await checkNavigationState();
		}
		else {
			console.log('ischecking==true, not calling checkNavigationState');
		}

		return;
	}

	const checkNavigationState = async () => {
		console.log('CardView.checkNavigationState called');

		setIsChecking(true);

		let mvcmywidget = theapp.getMvcMyWidget();
		var start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		context._refresh_page = false;

		try {
			let rootsessionuuid = await theapp.getRootSessionUUID();
			let devicewallet = await theapp.getDeviceWallet();
			let walletuuid = devicewallet.uuid;
	
			let currentscheme = context.currentscheme;
			let currentcard = context.currentcard;
			let currency = context.currency;


			if (currency && currentcard) {
				setCardAddress(currentcard.address);

				// TODO: this can create a hanging problem because of the 'load promise on the backburner' of ethereum_core's ContractInstance
				let _pos = await mvcmywidget.getCurrencyPosition(rootsessionuuid, walletuuid, currency.uuid, currentcard.uuid);
						
				if (_pos !== undefined) {
					let _card_balance_int = await _pos.toInteger();
					let _card_balance_string = await mvcmywidget.formatCurrencyAmount(rootsessionuuid, currency.uuid, _pos);
						
					if (balance != _card_balance_int)
					setBalance(_card_balance_int);

					if (balance_string != _card_balance_string)
					setBalanceString(_card_balance_string);
				}

				const credits = await mvcmywidget.getCardCreditBalance(rootsessionuuid, walletuuid, currentcard.uuid);
				setCreditBalance(credits.transactionunits);

			}

			if ((start_conditions.local_wallet_hide === true) || (start_conditions.local_wallet_hide === 'true')){
				// specified to hide access to local wallet
				setShowLocalWallet(false);
			}

			if ((start_conditions.remote_wallet_hide === true) || (start_conditions.remote_wallet_hide === 'true')){
				// specified to hide access to remote wallet
				setShowRemoteWallet(false);
			}


	

		}
		catch(e) {
			console.log('exception in CardView.checkNavigationState: ' + e);
		}
		finally {
			console.log('final statements in CardView.checkNavigationState');

			setIsChecking(false);

			// refresh page, if required
			if (context._refresh_page)					
			theapp.refreshPage();
		}

	}
	
	useEffect(() => {
		console.log('CardView.useEffect called');

		let mvcmywidget = theapp.getMvcMyWidget();
		let _uuid = mvcmywidget.guid();

		checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err)});

		mvcmywidget.registerEventListener('on_refreshPage', _uuid, onRefreshPage);
		return () => {
			mvcmywidget.unregisterEventListener('on_refreshPage', _uuid);
		};
	}, []);


	// API


	//
	// Small Size
	//
	const renderSmall = () => {
		return (
			<div className="sw-PaymentLinkWidgetBlock">

				<div className="sw-PaymentLinkRefreshIcon">
						<FontAwesomeIcon 
						icon={faSync}
						onClick={onRefresh}
						/>
				</div>

				<div className="sw-PayBalanceLine">
					<span><FormLabel>{theapp.t('Balance')}</FormLabel></span>
					<span className="sw-PayBalanceInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={balance_string}
					/></span>
				</div>

				<div className="sw-PaymentLinkToAddressLine">
					<span><FormLabel>{theapp.t('Address')}</FormLabel></span>
					<span className="sw-PaymentLinkToAddressInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={theapp.getMvcMyWidget().fitString(card_address, 24)}
					/></span>
				</div>


				<div className="sw-PayCreditLine">
					<span><FormLabel>{theapp.t('Tx Credits')}</FormLabel></span>
					<span className="sw-PayBalanceInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={credit_balance}
					/></span>
				</div>

				<div className="sw-PayOpenWalletLine">
					{(showremotewallet ? 
					<span className="sw-PayLoadCardIcon">
						<FontAwesomeIcon 
						icon={faUpload}
						onClick={onLoadCard}
						/>
					</span> :
					<></>)}
					{(showlocalwallet ? 
					<span className="sw-PayOpenWalletIcon">
						<FontAwesomeIcon 
						icon={faCreditCard}
						onClick={onOpenWallet}
						/>
					</span> :
					<></>)}
				</div>

				<div className="sw-PaymentLinkVersionInfo" >{theapp.current_version}</div>


			</div>
		);
	}	

	const renderComponent = () => {
		switch(widgetsize) {
			default:
			return renderSmall();
		}
	}
	
	return (

		<div>
			{renderComponent()}
		</div>

	);
}

export default CardView;